"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyValue = exports.safeJsonParse = exports.getNestedProperty = void 0;
function getNestedProperty(obj, propString, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (!obj || !propString || typeof propString !== 'string') {
        return null;
    }
    var props = propString.split('.');
    var tmpObj = obj;
    for (var i = 0; i < props.length; i++) {
        var currProp = props[i];
        if (!!tmpObj && tmpObj[currProp] !== undefined) {
            tmpObj = tmpObj[currProp];
        }
        else {
            return defaultValue;
        }
    }
    return tmpObj;
}
exports.getNestedProperty = getNestedProperty;
function safeJsonParse(stringToParse) {
    if (stringToParse === null || stringToParse === undefined) {
        return null;
    }
    try {
        return typeof stringToParse === 'object'
            ? stringToParse
            : JSON.parse(stringToParse);
    }
    catch (e) {
        console.warn('safeJsonParse function: cannot parse string');
        return null;
    }
}
exports.safeJsonParse = safeJsonParse;
function isEmptyValue(value) {
    return value === undefined || value === null || value === '';
}
exports.isEmptyValue = isEmptyValue;
//# sourceMappingURL=object.js.map